import { Card } from 'antd';
import { useTranslation } from 'react-i18next';
import { Datagrid } from 'components';
import { Tool } from 'app/types/tool';

const Logs = ({ tool }: { tool: Tool }) => {
  const { t } = useTranslation();

  return (
    <Card title={t('common.log')}>
      <Datagrid
        data={tool}
        keys={[
          'ModifiedAt',
          'ModifiedBy',
          'CreatedAt',
          'CreatedBy',
        ]}
        translationsNamespace="common"
      />
    </Card>
  );
};

export default Logs;
